"use strict";
/*
 * Created on 08 26 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of {@link Stock}.
 *
 * @author JMe
 */


var StockConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(StockConverter, _DataObjectConverter_);

  function StockConverter() {
    _classCallCheck(this, StockConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(StockConverter).apply(this, arguments));
  }

  return StockConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.StockConverter = StockConverter;